import "./Table.css";

export default function Table({ headings, className, children }) {
    return (
        <div className="table_wrapper">
            <div className={`table ${className ?? ''}`}>
                <table>
                    <thead>
                        <tr>
                            {headings?.map((heading, i) => <th key={i}>{heading}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {children}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export function TableCell({ className, children, cellScroll = true, ...rest }) {
    return (
        <td
            {...(className ? { className } : {})}
            {...rest}
        >
            <div className={`td_cell ${cellScroll ? 'cell_scroll' : 'elipsis_cell'}`}>
                {children}
            </div>
        </td>
    )
}

